import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "search", "container", 'dropdown', 'selectedValues', 'template']

  connect() {
    this.dropdown = new bootstrap.Dropdown(this.dropdownTarget)
  }

  toggle(event) {
    this.dropdown.toggle()
  }

  filter() {
    const query = this.searchTarget.value.toLowerCase()
    let visibleCount = 0

    this.checkboxTargets.forEach(checkbox => {
      const label = checkbox.nextElementSibling?.textContent.toLowerCase() || ''
      const container = checkbox.closest('.form-check')
      const isVisible = label.includes(query)
      container.classList.toggle('d-none', !isVisible)
      if (isVisible) visibleCount++
    })

    if (!this.hasContainerTarget) return

    this.containerTarget.style.maxHeight = `${Math.min(visibleCount * 32, 280)}px`
  }

  selectAll() {
    this.checkboxTargets.forEach(checkbox => checkbox.checked = true)
  }

  clear() {
    this.checkboxTargets.forEach(checkbox => checkbox.checked = false)
  }

  closeDropdown() {
    bootstrap.Dropdown.getInstance(this.dropdownTarget).hide()
  }

  selectCategory(event) {
    const category = event.currentTarget.dataset.category
    this.checkboxTargets.forEach(checkbox => {
      if (checkbox.dataset.category === category) {
        checkbox.checked = true
      }
    })
  }

  clearCategory(event) {
    const category = event.currentTarget.dataset.category
    this.checkboxTargets.forEach(checkbox => {
      if (checkbox.dataset.category === category) {
        checkbox.checked = false
      }
    })
  }
}
